// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeleccionPreguntaPerfilModal_labelTitulo__spBPH {
  margin-left: 20px;
  padding-top: 30px;
}

.SeleccionPreguntaPerfilModal_containerCuerpo__097\\+s {
  background-color: white;
}

.SeleccionPreguntaPerfilModal_divFormulario__WVZMZ {
  width: 100%;
}

p {
  width: 100%;
  flex-wrap: wrap;
}

.SeleccionPreguntaPerfilModal_divBotonera__eBHtX {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.SeleccionPreguntaPerfilModal_circleImage__njSBG {
  width: 100%; /* Ajusta el tamaño según tus necesidades */
  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
}

.SeleccionPreguntaPerfilModal_contenedorPreguntas__L9ZUG {
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  border-color: #707070;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 15px;
}

.SeleccionPreguntaPerfilModal_preguntaFondoIncluida__df54N {
  display: flex;
  flex-direction: row;
  background-color: rgb(229, 227, 227);
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  border-color: #707070;
  padding: 20px;
  margin-bottom: 15px;
  cursor: default;
  color: gray;
}

.SeleccionPreguntaPerfilModal_preguntaFondoNoIncluida__zfnv2 {
  display: flex;
  flex-direction: row;
  background-color: white;
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  border-color: #707070;
  padding: 20px;
  margin-bottom: 15px;
  cursor: pointer;
}

.SeleccionPreguntaPerfilModal_pregunta__7WgMm {
  font-weight: bold;
  font-size: 1.2rem;
}
.SeleccionPreguntaPerfilModal_cantAlternativas__ld8KE {
  margin-top: 10px;
}

.SeleccionPreguntaPerfilModal_divPregunta__jBjks {
  flex: 1 1;
}

.SeleccionPreguntaPerfilModal_divBotones__91The {
  width: auto;
}

@media (min-width: 768px) {
  /* Ajusta este valor según tus necesidades */
  .SeleccionPreguntaPerfilModal_containerGrillaUsuarios__oGhYT {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .SeleccionPreguntaPerfilModal_containerUsuario__l47A6 {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */
    margin: 10px; /* Agrega un poco de margen entre los botones */
  }

  .SeleccionPreguntaPerfilModal_circleImage__njSBG {
    width: 30%; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
    border-radius: 50%; /* Esto crea el círculo */
    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1100px) {
  .SeleccionPreguntaPerfilModal_containerUsuario__l47A6 {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */
  }
}

.SeleccionPreguntaPerfilModal_modalHeader__Y6dfW,
.SeleccionPreguntaPerfilModal_modalFooter__nH7AB {
  flex: 0 0 auto;
  padding: 1rem;
  background: #f5f5f5;
}

.SeleccionPreguntaPerfilModal_modalContent__LFcDT {
  flex: 1 1 auto; /* Esto permite que la sección crezca */
  overflow-y: auto; /* Hace que solo esta sección sea scrolleable */
  padding: 1rem;
}

.SeleccionPreguntaPerfilModal_divFormulario__WVZMZ {
  display: flex;
  flex-direction: column;
  height: 90vh; /* Ajusta la altura máxima del modal */
  max-height: 90vh;
  width: 50vw; /* Ancho del modal */
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden; /* Para evitar desbordamientos */
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/encuestas/encuestas-edicion/seleccion-pregunta-perfil/SeleccionPreguntaPerfilModal.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;IAC1E,YAAY,EAAE,+CAA+C;EAC/D;;EAEA;IACE,UAAU,EAAE,2CAA2C;IACvD,YAAY,EAAE,8EAA8E;IAC5F,kBAAkB,EAAE,yBAAyB;IAC7C,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;AACF;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,uCAAuC;EACvD,gBAAgB,EAAE,+CAA+C;EACjE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,sCAAsC;EACpD,gBAAgB;EAChB,WAAW,EAAE,oBAAoB;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB,EAAE,gCAAgC;AACpD","sourcesContent":[".labelTitulo {\n  margin-left: 20px;\n  padding-top: 30px;\n}\n\n.containerCuerpo {\n  background-color: white;\n}\n\n.divFormulario {\n  width: 100%;\n}\n\np {\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.circleImage {\n  width: 100%; /* Ajusta el tamaño según tus necesidades */\n  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.contenedorPreguntas {\n  display: flex;\n  flex-direction: column;\n  background-color: #f8fafc;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 8px;\n  border-color: #707070;\n  padding-top: 30px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-bottom: 15px;\n}\n\n.preguntaFondoIncluida {\n  display: flex;\n  flex-direction: row;\n  background-color: rgb(229, 227, 227);\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 8px;\n  border-color: #707070;\n  padding: 20px;\n  margin-bottom: 15px;\n  cursor: default;\n  color: gray;\n}\n\n.preguntaFondoNoIncluida {\n  display: flex;\n  flex-direction: row;\n  background-color: white;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 8px;\n  border-color: #707070;\n  padding: 20px;\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n\n.pregunta {\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n.cantAlternativas {\n  margin-top: 10px;\n}\n\n.divPregunta {\n  flex: 1;\n}\n\n.divBotones {\n  width: auto;\n}\n\n@media (min-width: 768px) {\n  /* Ajusta este valor según tus necesidades */\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */\n    margin: 10px; /* Agrega un poco de margen entre los botones */\n  }\n\n  .circleImage {\n    width: 30%; /* Ajusta el tamaño según tus necesidades */\n    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n    border-radius: 50%; /* Esto crea el círculo */\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1100px) {\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n}\n\n.modalHeader,\n.modalFooter {\n  flex: 0 0 auto;\n  padding: 1rem;\n  background: #f5f5f5;\n}\n\n.modalContent {\n  flex: 1 1 auto; /* Esto permite que la sección crezca */\n  overflow-y: auto; /* Hace que solo esta sección sea scrolleable */\n  padding: 1rem;\n}\n\n.divFormulario {\n  display: flex;\n  flex-direction: column;\n  height: 90vh; /* Ajusta la altura máxima del modal */\n  max-height: 90vh;\n  width: 50vw; /* Ancho del modal */\n  background-color: #fff;\n  border-radius: 8px;\n  overflow: hidden; /* Para evitar desbordamientos */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelTitulo": `SeleccionPreguntaPerfilModal_labelTitulo__spBPH`,
	"containerCuerpo": `SeleccionPreguntaPerfilModal_containerCuerpo__097+s`,
	"divFormulario": `SeleccionPreguntaPerfilModal_divFormulario__WVZMZ`,
	"divBotonera": `SeleccionPreguntaPerfilModal_divBotonera__eBHtX`,
	"circleImage": `SeleccionPreguntaPerfilModal_circleImage__njSBG`,
	"contenedorPreguntas": `SeleccionPreguntaPerfilModal_contenedorPreguntas__L9ZUG`,
	"preguntaFondoIncluida": `SeleccionPreguntaPerfilModal_preguntaFondoIncluida__df54N`,
	"preguntaFondoNoIncluida": `SeleccionPreguntaPerfilModal_preguntaFondoNoIncluida__zfnv2`,
	"pregunta": `SeleccionPreguntaPerfilModal_pregunta__7WgMm`,
	"cantAlternativas": `SeleccionPreguntaPerfilModal_cantAlternativas__ld8KE`,
	"divPregunta": `SeleccionPreguntaPerfilModal_divPregunta__jBjks`,
	"divBotones": `SeleccionPreguntaPerfilModal_divBotones__91The`,
	"containerGrillaUsuarios": `SeleccionPreguntaPerfilModal_containerGrillaUsuarios__oGhYT`,
	"containerUsuario": `SeleccionPreguntaPerfilModal_containerUsuario__l47A6`,
	"modalHeader": `SeleccionPreguntaPerfilModal_modalHeader__Y6dfW`,
	"modalFooter": `SeleccionPreguntaPerfilModal_modalFooter__nH7AB`,
	"modalContent": `SeleccionPreguntaPerfilModal_modalContent__LFcDT`
};
export default ___CSS_LOADER_EXPORT___;
